import { defineMessages, useIntl } from 'react-intl';

import type { AddressType } from '@sg/garnish';
import { AddressTypes } from '@sg/garnish';

export const useAddressTitle = (orderType: AddressType): string => {
  const { formatMessage } = useIntl();

  if (orderType === AddressTypes.pickup) {
    return formatMessage(messages.pickupLocationTitle);
  }

  if (orderType === AddressTypes.delivery) {
    return formatMessage(messages.deliveryLocationTitle);
  }

  if (orderType === AddressTypes.outpost) {
    return formatMessage(messages.outpostLocationTitle);
  }

  return formatMessage(messages.inStoreLocationTitle);
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  pickupLocationTitle: {
    defaultMessage: 'Pickup location',
    description: 'Order Status | Location | Title Pickup',
  },
  deliveryLocationTitle: {
    defaultMessage: 'Delivery location',
    description: 'Order Status | Location | Title Delivery',
  },
  outpostLocationTitle: {
    defaultMessage: 'Outpost location',
    description: 'Order Status | Location | Title Outpost',
  },
  inStoreLocationTitle: {
    defaultMessage: 'Store location',
    description: 'Order Status | Location | Title In-store',
  },
});
